module.exports = __webpack_public_path__ + "static/media/laranja_moro.b8823d92.jpeg";